export default {
  type: {
    ERROR: 'error',
    INFO: 'info',
    PAYMENT: 'payment',
    SUCCESS: 'success',
    WARNING: 'warning',
  },
};
